import { useEffect, useRef, useState } from 'react';
import WebProductEdit from './WebProductEdit';
import { columnsheadId } from '../../universal/columnshead';
import { Button, Space, Tooltip, Image } from 'antd';
import WebProductPrice from './WebProductPrice';
import WebProductSpec from './WebProductSpec';
// import WebProductDetails from './WebProductDetails';
import WebProductFileEdit from './WebProductFileEdit';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';

const WebProduct = (props: any) => {
    const ref = useRef<any>(undefined);
    /** 服务id */
    const apiId = 'webProduct';

    //规格窗口
    const [modalProductSpecVisible,
        setModalProductSpecVisible] = useState(false);
    //规格数据
    const [productSpecData, setProductSpecData] = useState<any>();
    //价格窗口
    const [modalProductPriceVisible,
        setModalProductPriceVisible] = useState(false);
    //价格数据
    const [productPriceData, setProductPriceData] = useState<any>();
    //产品详情窗口
    // const [modalProductDetailsVisible,
    //     setModalProductDetailsVisible] = useState(false);
    //产品详情数据    
    // const [productDetailsData, setProductDetailsData] = useState<any>();

    useEffect(() => {

    }, []);


    //传关参数
    let sendData = {
        type: 'EDIT',
        id: '',
        productName: ''
    }
    //打开产品价格
    const hanldProductPrice = (e: any) => {
        sendData.id = e;
        setProductPriceData(sendData);
        setModalProductPriceVisible(true);
    };
    //关闭产品价格，子组件回调函数
    const onCloseModalPriceVisible = (state: boolean) => {
        setModalProductPriceVisible(false);
        ref?.current?.fetchData?.();
    };
    //打开产品规格
    const hanldProductSpec = (e: any) => {
        sendData.id = e;
        setProductSpecData(sendData);
        setModalProductSpecVisible(true);
    };
    //关闭产品规格，子组件回调函数
    const onCloseModalSpecVisible = (state: boolean) => {
        setModalProductSpecVisible(false);
        ref?.current?.fetchData?.();
    };
    //打开产品详情
    // const hanldProductDetails = (record: any) => {
    //     sendData.id = record.id;
    //     sendData.productName = record.productName;
    //     console.log('打开产品详情');
    //     console.log(sendData);
    //     setProductDetailsData(sendData);
    //     setModalProductDetailsVisible(true);
    // }
    //关闭产品详情，子组件回调函数
    // const onCloseModalDetailsVisible = (state: boolean) => {
    //     setModalProductDetailsVisible(false);
    // };


    //表头
    const columnsHead = [
        {
            title: '名称',
            dataIndex: 'productName',
            sorter: true,
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 10 ? text.substring(0, 10) + '......' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '月销量',
            dataIndex: 'monthlyQuantitySold',
            sorter: true,
        },
        {
            title: '店铺',
            dataIndex: 'shop',
            render: (text: any) => (
                text ? text.shopName : ''
            )

        },
        {
            title: '分类',
            dataIndex: 'productType',
            sorter: true,
            render: (text: any) => (
                text ? text.typeName : '')
        },
        {
            title: '规格',
            dataIndex: 'productSpec',
            key: 'productSpec',
            render: (text: any, record: any) =>
                <Space size="small">
                    <Button size={"small"} type="primary" onClick={() => hanldProductSpec(record.id)}>规格</Button>
                </Space>
        },
        {
            title: '价格',
            dataIndex: 'productPrice',
            key: 'productPrice',
            render: (text: any, record: any) =>
                <Space size="small">
                    <Button size={"small"} type="primary" onClick={() => hanldProductPrice(record.id)}>价格</Button>
                </Space>
        },
        // {
        //     title: '详情',
        //     dataIndex: 'id',
        //     key: 'id',
        //     render: (text: any, record: any) =>
        //         <Space size="small">
        //             <Button size={"small"} type="primary" onClick={() => hanldProductDetails(record)}>详情</Button>
        //         </Space>
        // },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    //表头
    const filesColumns = [
        {
            title: '产品',
            dataIndex: 'product',
            render: (text: any) => (text.productName)
        },
        {
            title: '广告图片',
            dataIndex: 'isAd',
            render: (text: any) => (text ? '是' : '否')
        },
        {
            title: '图片',
            dataIndex: 'id',
            render: (text: any, record: any) => (
                < Image
                    src={`${record.serverUrl}/${record.fileDestination}`}
                    width={60}
                    alt="图片" />
            )
        }
    ];

    let extendProps: WebUniversalProps = {
        titleName: '产品',
        apiId,
        columns,
        editOptions: {
            Editor: WebProductEdit
        },
        displayOptions: {
            showFiles: true
        },
        filesOptions: {
            FilesEditComponent: WebProductFileEdit,
            filesColumns,
            fileParentId: 'productId',
            insertFile: async (payload) => {
                const { sendPageData, fileRows } = payload;
                let currentFileRows = [];
                for (let i = 0; i < fileRows.length; i++) {
                    const item = fileRows[i];
                    currentFileRows.push({
                        productId: sendPageData.productId,
                        serverUrl: item.serverUrl,
                        fileId: item.id,
                        fileDestination: `${item.destination}/${item.fileName}`,
                        fileType: item.fileType,
                        fileSize: item.fileSize,
                        imageWidth: item.imageWidth,
                        imageHeight: item.imageHeight,
                        isDefault: false,
                        isUse: true
                    })
                }
                const insertRes = await fetchApi.POST(ref.current?.defaultService,
                    {
                        body: {
                            apiId: `${apiId}File`,
                            apiExtend: 'batchAddFiles',
                            apiData: {
                                fileRows: currentFileRows
                            }
                        }
                    })
                return insertRes;
            },
        }
    };

    return (
        <>
            <WebUniversal {...extendProps} ref={ref} />
            {modalProductPriceVisible
                ? (<WebProductPrice
                    closeModal={onCloseModalPriceVisible}
                    data={productPriceData} />)
                : null}
            {modalProductSpecVisible
                ? (<WebProductSpec
                    closeModal={onCloseModalSpecVisible}
                    data={productSpecData} />)
                : null}
            {/* {modalProductDetailsVisible
                ? (<WebProductDetails
                    key={productDetailsData.id}
                    onClose={onCloseModalDetailsVisible}
                    data={productDetailsData} />)
                : null} */}
            {/* {modalFilesExtendsManageVisible
                ? (<FilesExtendsManage
                    apiId={apiId + 'File'}
                    closeModal={() => setModalFilesExtendsManageVisible(false)
                     de
                    }
                />)
                : null} */}


        </>
    )
}

export default WebProduct;